export const QUOTATION_FORM_TYPE = {
  NORMAL_QUOTATION: 1,
  SYNGENTA_QUOTATION: 2,
  AGRO_INSURANCE_QUOTATION: 9,
};
